import { FAILURE, REQUEST, SUCCESS } from 'src/redux/constants';
import { GET_JOURNAL } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { IJournalActionTypes } from './types';
import auditApi from 'src/utils/api/auditApi';

export const getJournal =
  (
    params: string,
  ): ThunkAction<Promise<void>, State, null, IJournalActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: GET_JOURNAL + REQUEST });
    try {
      const payload = await auditApi.getJournal(params);
      dispatch({ type: GET_JOURNAL + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: GET_JOURNAL + FAILURE, error });
    }
  };
